import React from "react";
import { Outlet, useNavigate } from "react-router-dom";

import '../assets/css/agents.css';
import '../assets/css/mainLayout.css';
import { NotificationProvider } from "../components/common/NotificationProvider";
import { ACCESS_TOKEN, websocketModuleType } from "../settings/shared/constants";


const LayoutMain = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const handleMessageReceived = (event) => {
      if (!event) return;
      let message = event.detail;
      try {
        if (typeof message === "string") {
          message = JSON.parse(message);
        }
      } catch (e) {
        console.error("Failed to parse websocket message", e);
        return;
      }
      if (!message || typeof message !== "object") return;

      const moduleType = message.ninfo?.moduleType || message.moduleType;
      if (moduleType === websocketModuleType.STORAGE || moduleType === "STORAGE") {
        window.dispatchEvent(new CustomEvent("storageMessageReceived", { detail: message }));
      } else if (moduleType === websocketModuleType.CLUSTER || moduleType === "CLUSTER") {
        window.dispatchEvent(new CustomEvent("clusterMessageReceived", { detail: message }));
      } else if (moduleType === websocketModuleType.POD || moduleType === "POD") {
        window.dispatchEvent(new CustomEvent("podMessageReceived", { detail: message }));
      } else if (moduleType === websocketModuleType.CODER || moduleType === "CODER") {
        window.dispatchEvent(new CustomEvent("chatMessageReceived", { detail: message }));
      } else if (moduleType === websocketModuleType.AGENT_EXECUTION || moduleType === "AGENT_EXECUTION") {
        window.dispatchEvent(new CustomEvent("agentMessageReceived", { detail: message }));
      } else if (moduleType === websocketModuleType.WORKFLOW_STATUS || moduleType === "WORKFLOW_STATUS") {
        window.dispatchEvent(new CustomEvent("workflowStatusMessageReceived", { detail: message }));
      } else if (moduleType === websocketModuleType.CHECKPOINT_RESTORE || moduleType === "CHECKPOINT_RESTORE") {
        window.dispatchEvent(new CustomEvent("checkpointRestoreMessageReceived", { detail: message }));
      } else if (moduleType === websocketModuleType.SCM || moduleType === "SCM") {
        window.dispatchEvent(new CustomEvent("scmMessageReceived", { detail: message }));
      }    
    };
    
    window.addEventListener('messageReceived', handleMessageReceived);
    // Check for ACCESS_TOKEN and navigate accordingly
    if (localStorage.getItem(ACCESS_TOKEN) === null) {
      navigate('/auth/login');
    } 

    return () => {
      window.removeEventListener('messageReceived', handleMessageReceived);
    };
  }, [navigate]); 


  return (
    <NotificationProvider>
     <main>
      <Outlet />
      {/* <WebSocketStatusIndicator /> */}
     </main>
     </NotificationProvider>
  );
};

export default LayoutMain;
